var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForklift(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1355_695)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 20,
    r: 13,
    fill: "#F2F2F2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17H18V13.5C18 12.6719 18.6719 12 19.5 12H24.1469C24.7813 12 25.3469 12.4 25.5594 12.9969L27.9125 19.5844C27.9688 19.7469 28 19.9156 28 20.0875V22.7656C28.6125 23.3156 29 24.1125 29 25.0031C29 26.6594 27.6562 28.0031 26 28.0031C24.3438 28.0031 23 26.6594 23 25.0031H21C21 26.6594 19.6562 28.0031 18 28.0031C16.3438 28.0031 15 26.6594 15 25.0031V18.5C15 17.6719 15.6719 17 16.5 17ZM23 20H25.9375L23.7937 14H20V17L23 20ZM18 26.5C18.8281 26.5 19.5 25.8281 19.5 25C19.5 24.1719 18.8281 23.5 18 23.5C17.1719 23.5 16.5 24.1719 16.5 25C16.5 25.8281 17.1719 26.5 18 26.5ZM26 26.5C26.8281 26.5 27.5 25.8281 27.5 25C27.5 24.1719 26.8281 23.5 26 23.5C25.1719 23.5 24.5 24.1719 24.5 25C24.5 25.8281 25.1719 26.5 26 26.5ZM32 13V24H34C34.5531 24 35 24.4469 35 25C35 25.5531 34.5531 26 34 26H31C30.4469 26 30 25.5531 30 25V13C30 12.4469 30.4469 12 31 12C31.5531 12 32 12.4469 32 13Z",
    fill: "#132439"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1355_695",
    x: 12,
    y: 7,
    width: 26,
    height: 27,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1355_695"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForklift);
export default __webpack_public_path__ + "static/media/forklift.322e5052fcc9ce47b2f506268aa1f711.svg";
export { ForwardRef as ReactComponent };